import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import AlmeDropdown from './AlmeDropdown/AlmeDropdown';
import * as Constants from './AlmeInlineConstants';
import Button from 'syf-component-library/ui/atoms/Button';
import InlineDatepicker from './Datepicker/InlineDatepicker';
import { formatdate, parseDate } from '../AlmeUtilities/dateutils';
const FormWrapper = styled.div `
    width: 100%;
    margin-top: 10px;
`;
const ButtonWrapper = styled.div `
    margin-top: 15px;
    padding-left: 3px;
    display: flex;
    > button:last-child {
        margin-left: 5px;
    }
`;
const StyledButtonDatePicker = styled(Button) `       
   min-width: 273px;
   max-height:30px;   
`;
const StyledButton = styled(Button) `
  min-width: 88px;  
  max-height:32px;
  font-size: ${props => props.theme.fontSizes.promptText};
`;
function getDefaultValue(responseAction) {
    if (responseAction.Name === Constants.LAUNCHPICKERINPUT) {
        const dropdownResponseAction = responseAction;
        const initialValue = dropdownResponseAction.InitialValue;
        let defaultValue;
        if (typeof initialValue === 'number') {
            defaultValue = dropdownResponseAction.Values[initialValue];
        }
        else {
            defaultValue = dropdownResponseAction.Values.find(o => o.SubmitValue === initialValue);
        }
        return (defaultValue && defaultValue.SubmitValue) || dropdownResponseAction.Values[0].SubmitValue;
    }
    else {
        const date = responseAction.ReferenceDate;
        return (date && parseDate(date)) || null;
    }
}
function formSubmitParams(widgetSelection, endType) {
    return ({
        WidgetSelection: widgetSelection,
        endType,
    });
}
const AlmeInlineForm = (props) => {
    const [formValue, setFormValue] = useState(() => {
        const defaultValue = getDefaultValue(props.responseAction);
        return ({ value: defaultValue, valid: !!(defaultValue === 0 || defaultValue) });
    });
    const onChange = (val) => {
        setFormValue(val);
    };
    const onSubmit = () => {
        var _a;
        if (formValue.valid) {
            const eventName = (_a = props.responseAction) === null || _a === void 0 ? void 0 : _a.ReturnAppEventName;
            const input = formValue.value instanceof Date ? formatdate(formValue.value) : String(formValue.value); //Convert all values to string
            const parameters = formSubmitParams(input, 'Completed');
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
        }
    };
    const onCancel = () => {
        var _a;
        const eventName = (_a = props.responseAction) === null || _a === void 0 ? void 0 : _a.ReturnAppEventName;
        const parameters = formSubmitParams('', 'Canceled');
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
    };
    const managefocus = useCallback((event) => {
        const formInputs = document.getElementById("formInputs");
        if (event.key === "Escape") {
            const comboboxElement = formInputs === null || formInputs === void 0 ? void 0 : formInputs.getElementsByTagName("div")[2];
            if (comboboxElement && document.activeElement === document.body) {
                event.preventDefault();
                comboboxElement.focus();
            }
        }
    }, []);
    useEffect(() => {
        document.addEventListener("keydown", managefocus, false);
        return () => {
            document.removeEventListener("keydown", managefocus, false);
        };
    }, [managefocus]);
    return (React.createElement(FormWrapper, { id: "formInputs" },
        props.responseAction.Name === Constants.LAUNCHPICKERINPUT
            ? React.createElement(AlmeDropdown, { value: formValue.value, responseAction: props.responseAction, responseRevision: props.responseRevision, onChange: onChange, disabled: props.disabled })
            : React.createElement(InlineDatepicker, { value: formValue.value, responseAction: props.responseAction, responseRevision: props.responseRevision, onChange: onChange, disabled: props.disabled }),
        React.createElement(ButtonWrapper, null, props.responseAction.Name === Constants.LAUNCHDATEPICKERINPUT
            ? React.createElement(StyledButtonDatePicker, { onClick: onSubmit, buttonType: 'primary', id: `inline-form-submit-button-${props.responseRevision}`, disabled: props.disabled }, "Submit")
            :
                React.createElement(React.Fragment, null,
                    "  ",
                    React.createElement(StyledButton, { onClick: onSubmit, buttonType: 'primary', id: `inline-form-submit-button-${props.responseRevision}`, disabled: props.disabled }, "Submit"),
                    React.createElement(StyledButton, { onClick: onCancel, buttonType: 'primary', id: `inline-form-submit-button-${props.responseRevision}`, disabled: props.disabled }, "Cancel"))),
        props.responseAction.Name === Constants.LAUNCHDATEPICKERINPUT
            ? React.createElement(StyledButtonDatePicker, { onClick: onCancel, buttonType: 'ghost', id: `inline-form-cancel-button-${props.responseRevision}`, disabled: props.disabled }, "Cancel")
            : null));
};
export default AlmeInlineForm;
